
/*
    Display for an individual reassignment report record
*/

import React from "react";

import DataItem from "../Components/DataItem";

/*
    date: "10/22/2020",
    route: "119",
    run: "22",
    scheduledTime: "05:35",
    previousVehicleID: "324",
    oldRoute: "301",
    oldRun: "25",
    newVehicleID: "101",
    timeUpdated: "05:55"
*/

/*
--action: "reassignment"
--source_internal_trip_number: "18028651"
source_route: "154"
source_run_id: "3"
source_sched__dep_time: "5/18/2022 10:45:00 AM"
source_scheduled_lane_gate: "203-1"
--source_timing_point_id: "NWYKPABT"
source_vehicle_id: "9002"
starter: "VISSRXN"
--target_internal_trip_number: "17900122"
target_route: "119"
target_run_id: "2"
target_sched__dep_time: "5/18/2022 10:50:00 AM"
target_scheduled_lane_gate: "208-1"
--target_timing_point_id: "NWYKPABT"
target_vehicle_id: "6018"
--timestamp: "5/18/2022 1
*/

export default class ReportReassignmentData extends React.Component {
    render() {

        const {data} = this.props;

        const formatDate = (dt) => {
            const AMPM = dt.substring(dt.length - 2);
            const date = new Date(dt);

            let hours = date.getHours();
            if(hours > 12) {
                hours -= 12;
            }

            let minutes = date.getMinutes();
            if(minutes < 10) {
                minutes = "0" + minutes;
            }

            return `${date.getDay()}/${date.getMonth()} ${hours}:${minutes} ${AMPM}`;
        }

        const sourceDate = formatDate(data.source_sched__dep_time);
        const targetDate = formatDate(data.target_sched__dep_time);

        return (
            <div className="data" style={{
                display: "grid",
                gridTemplateColumns: "2fr 2fr 2fr 2fr 3fr 3fr",
                justifyItems: "flex-start",
                gridGap: "4px",
                padding: "8px 4px 8px 32px"
            }}>
                <div>{data.starter}</div>
                <div>Route: <DataItem val={data.target_route} /></div>
                <div>Run: <DataItem val={data.target_run_id} /></div>
                <div>Pass: <DataItem val={data.passCount} /></div>
                <div>Scheduled: <DataItem val={targetDate} /></div>
                <div>Vehicle ID#: <DataItem val={data.target_vehicle_id} /></div>
                {/* new line */}
                <div style={{color: "#bb0000"}}>OLD VALUES --&gt;</div>
                <div>
                    <span style={{color: "#bb0000"}}>Route: </span> 
                    <DataItem val={data.source_route} />
                </div>
                <div>
                    <span style={{color: "#bb0000"}}>Run: </span>
                    <DataItem val={data.source_run_id} />
                </div>
                <div>{/* nothing to show here for passengers, right? */}</div>
                <div>
                    <span style={{color: "#bb0000"}}>Scheduled: </span>
                    <DataItem val={sourceDate} />
                </div>
                <div>
                    <span style={{color: "#bb0000"}}>Previous ID: </span>
                    <DataItem val={data.source_vehicle_id} />
                </div>
            </div>
        );
    }
}